import { Tent, Music, ShieldCheck } from "lucide-react";
import { BrutalCard, Badge } from "../common/Brutal";

const REASONS = [
  { icon: Tent, title: "Pick Your Zone", desc: "From Aliw to Sigla — pitch your tent or pull in your car." },
  { icon: Music, title: "Live The Schedule", desc: "Experience the vibrant pulse of CamSur and turn every moment into a memory." },
  { icon: ShieldCheck, title: "Safe & Organised", desc: "On-site medics, fire wardens and 24/7 security across all zones and CamSur Uptown." },
];

export const LandingWhy = () => (
  <section id="why" className="max-w-7xl mx-auto px-4 py-16">
    <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
      <div>
        <Badge color="magenta">Why KAOGMA</Badge>
        <h2 className="display text-4xl sm:text-5xl mt-3 text-[#3D1E6D]">
          A festival you live in,
          <br />
          not just visit.
        </h2>
      </div>
      <p className="max-w-md text-[#6B4E9E]">
        KAOGMA is a 6-day immersive and the hottest festival in the world
        happening at the CamSur Uptown. Book your zone, get a personal QR
        pass for every camper in your group, and live the rhythm.
      </p>
    </div>
    <div className="grid md:grid-cols-3 gap-6">
      {REASONS.map(({ icon: Icon, title, desc }, i) => (
        <BrutalCard key={i} className="p-6" hover>
          <Icon className="h-8 w-8 text-[#E5247C]" strokeWidth={2.75} />
          <h3 className="display text-2xl mt-4 text-[#3D1E6D]">{title}</h3>
          <p className="mt-2 text-[#6B4E9E]">{desc}</p>
        </BrutalCard>
      ))}
    </div>
  </section>
);
